var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhubdActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7396_368581)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.556 7.05013L14.321 2.06912C12.948 0.977125 11.028 0.976125 9.649 2.07113L3.459 7.03813C2.702 7.61212 2.261 8.48312 2.25 9.43612V20.0061C2.25 20.4201 2.586 20.7561 3 20.7561C3.414 20.7561 3.75 20.4201 3.75 20.0061V9.44413C3.755 8.96712 3.98 8.52612 4.382 8.22112L10.585 3.24313C11.41 2.58913 12.563 2.58713 13.386 3.24213L19.641 8.23712C20.015 8.51612 20.243 8.96812 20.249 9.43612V20.0061C20.249 20.4201 20.585 20.7561 20.999 20.7561C21.413 20.7561 21.749 20.4201 21.749 20.0061V9.42513C21.735 8.48213 21.282 7.58913 20.556 7.05013Z",
    fill: "#1080FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1319 14.3015C14.1319 14.7706 13.7522 15.1391 13.2943 15.1391H10.7034C10.2455 15.1391 9.86582 14.7706 9.86582 14.3015C9.86582 13.8436 10.2455 13.4639 10.7034 13.4639H13.2943C13.7522 13.4639 14.1319 13.8436 14.1319 14.3015ZM14.1989 10.002H9.79881C8.00078 10.002 6.75 11.3086 6.75 13.1736V17.3168C6.75 19.193 8.00078 20.4996 9.79881 20.4996H14.1989C15.9969 20.4996 17.2477 19.193 17.2477 17.3168V13.1736C17.2477 11.3086 15.9969 10.002 14.1989 10.002Z",
    fill: "#1080FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7396_368581"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.00195312)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhubdActive);
export default __webpack_public_path__ + "static/media/phubd_active.7e747be11780fb2f3cb336b15f16c36e.svg";
export { ForwardRef as ReactComponent };